export default () => {
    return `
    <div class="search" id="searchframework">
        
    </div>   
    `
}

export const searchFrameWorkHtml = (q) => {
    return `
        <div class="searchheader">
            <div class="row">
                <div class="col-xl-4">
                    <h4 class="searchheader__title">Søk i kommuneleksikon</h4>
                </div>
                <div class="col-xl-4 p-0">
                    <div class="searchheader__input-group" role="search">
                        <input type="text" class="form-control form__input searchheader__forminput" id="searchheader__inputfield" placeholder="Søk etter f.eks. gatenavn" value="${q}">
                        <span class="input-group-btn">
                            <button class="form__hoversearch searchheader__hoversearch" id="searchheader__button" type="button">
                                <span class="material-icons-outlined form__hoversearch__icon">search</span>
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-lg-9">
                <div class="row searchcontent">
                
                    <div class="leftcol col-12 col-md-3" id="leftCol">
                        <div class="categories">
                            <div class="categories__header">
                                <div class="search__headertitle">Avgrens søket</div>
                            </div>
                            <div class="categories__selected"></div>
                            <div class="categories__list">
                                <div class="categories__collection"></div>
                            </div>
                        </div>
                    </div>
                
                    <div class="maincol col-12 col-md-9" id="mainCol">
                        <div class="searchresult__header">
                            <div class="searchresult__meta">
                                <div class="row">
                                    <div class="col-12 col-md-8">
                                        <div id="resultscount" class="searchresult__meta__count">Antall treff: <span id="searchresultHitscount"></span></div>
                                    </div>
                                    <!--
                                    <div class="col-12 col-md-4">
                                        <div class="dropdown searchresult__meta__dropdown__container">
                                            <label class="searchresult__meta__label">Sorter etter</label>
                                            <div class="searchresult__meta__dropdown">
                                                <button 
                                                    class="btn btn-default dropdown-toggle pull-right searchresult__meta__dropdown-button" 
                                                    type="button" 
                                                    id="dropdownMenu1" 
                                                    data-toggle="dropdown" 
                                                    aria-haspopup="true" 
                                                    aria-expanded="true">
                                                        <span class="btn-text searchresult__meta__choosedtxt">Relevans</span>
                                                        <span class="icon material-icons-outlined">&#xe5ce</span>
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-right searchresult__meta__dropdown-content" aria-labelledby="dropdownMenu1">
                                                    <li><span>Relevans</span></li>
                                                    <li><span>Dato</span></li>
                                                </ul>
                                            </div> 
                                        </div>
                                    </div>
                                    -->
                                </div>
                            </div>
                        </div>
                        <!-- / searchresult__header -->
                        <div class="searchresult">
                            <div class="searchresult__filter"></div>
                            <div class="">
                                <div class="searchresult__list list-unstyled"></div>
                            </div>
                            <div class="searchresult__footer">
                                <div class="searchresult__pagination"></div>
                            </div>
                        </div>
                        <!-- /searchresult -->
                    </div>
                </div>
            </div>
        </div>`
}

export const debugHtml = (matchObj) => {
    
    return `
    <h2>Index statistics</h2>
    <table>
        <tr><th>Product version:</th><td>` + matchObj[1] + `</td></tr>
        <tr><th>Total items:</th><td>` + matchObj[2] + `</td></tr>
        
        <tr><th>Active items:</th><td>` + matchObj[3] + `</td></tr>
        <tr><th>Deleted items:</th><td>` + matchObj[4] + `</td></tr>
        <tr><th>Last item id:</th><td>` + matchObj[5] + `</td></tr>
        <tr><th>Last item date:</th><td>` + matchObj[6] + `</td></tr>
        <tr><th>Memory working set:</th><td>` + matchObj[7] + `</td></tr>
        <tr><th>Free memory:</th><td>` + matchObj[8] + `</td></tr>
        <tr><th>Threads in use:</th><td>` + matchObj[9] + `</td></tr>
        <tr><th>Index diskspace usage:</th><td>` + matchObj[10] + `</td></tr>
        <tr><th>Free space on index drive:</th><td>` + matchObj[11] + `</td></tr>
        <tr><th>Physical processors:</th><td>` + matchObj[12] + `</td></tr>
        <tr><th>Physical cores:</th><td>` + matchObj[13] + `</td></tr>
        <tr><th>Logical cores:</th><td>` + matchObj[14] + `</td></tr>
        <tr><th>OS version:</th><td>` + matchObj[15] + `</td></tr>
        <tr><th>64bit OS:</th><td>` + matchObj[16] + `</td></tr>
        <tr><th>64bit process:</th><td>` + matchObj[17] + `</td></tr>
        <tr><th>.NET version:</th><td>` + matchObj[18] + `</td></tr>
        <tr><th>Current directory:</th><td>` + matchObj[19] + `</td></tr>
        <tr><th>Machine name:</th><td>` + matchObj[20] + `</td></tr>
        <tr><th>User:</th><td>` + matchObj[21] + `</td></tr>
        <tr><th>Interactive:</th><td>` + matchObj[22] + `</td></tr>
    </table><br/>
    `
}

export const resultUnit = (item) => {
    return `
        <div data-nr='${item.number}' class="searchresult__list__item" data-type="unit">
            <div class="searchresult__list__mal_enhetsmal">
                <h3 class="searchresult__list__title">
                    <a href="/${item.site}/${item.id}" class="searchresult__list__link">${item.title}</a>
                </h3>
                <p class="searchresult__list__desc">${item.extract}</p>
                <p class="searchresult__list__date">${item.pDate}</p>
            </div>
        </div>`;
}

export const resultContactCard = (item) => {
    return `
        <div data-nr='${item.number}' class="searchresult__list__item" data-type="contact">
            <div class="searchresult__list__mal_visittkort">
                <div class="searchresult__list__profile-icon">
                    <span class="budlight-profile-picture"></span>
                </div>
                <div class="searchresult__list__profile-data">
                    <h3 class="searchresult__list__title">
                        <a href="/${item.site}/${item.id}" class="searchresult__list__link">${item.title}</a>
                    </h3>
                    <p class="searchresult__list__desc">${ item.contact.personstilling }</p>
                    <p class="searchresult__list__desc">${ item.contact.personMobil }</p>
                    <p class="searchresult__list__desc">${ item.contact.personEpost }</p>
                </div>
            </div>
        </div>`;
}

export const resultFile = (item) => {
    return `
        <div data-nr='${item.number}' class="searchresult__list__item" data-type="file">
                <h3 class="searchresult__list__title"><span class="icon budlight-file"></span>
                    <a href="${item.filePath}" class="searchresult__list__link">${item.title}</a>
                </h3>
                <p class="searchresult__list__desc">${item.extract}</p>
                <p class="searchresult__list__date">${item.pDate}</p>
        </div>`;
}

export const resultDefault = (item) => {
    return `
        <div data-nr='${item.number}' class="searchresult__list__item  " data-type="default">
            <div class="row">
                ${item.image ? `
                <div class="col-lg-3 d-none d-lg-block">
                    
                        <img src="#" alt="" class="image__unresolved" data-id="${item.image}" >
                
                </div>` : ``}
                <div class="${item.image ? "col-lg-9" : "col-12"}">
                
                    <h3 class="searchresult__list__title">
                        <a href="/${item.site}/${item.id}" class="searchresult__list__link">${item.title}</a>
                    </h3>
                    <p class="searchresult__list__desc">${item.extract}</p>
                    <p class="searchresult__list__date">${item.pDate}</p>
                
                </div>
            </div>
        </div>`
}